import { TLocationState } from 'core/domains/router';

import { app } from 'core/use-cases';
import { put } from 'core/middlewares/utilities';
import { settings as settingsSelectors } from 'core/middlewares/effects/helpers';
import { history } from 'core/use-cases/utilities';

import { getters } from '../getters';

export function* setBreadcrumbs() {
  const { state: currentState } = history.location;

  const homePage: getters.RoutePath = yield getters.getHomepageRoute();
  const routes: settingsSelectors.SettingsRoutes = yield settingsSelectors.getRoutes();

  const state = currentState as TLocationState;

  yield put(app.actions.setBreadcrumbs({ homePage, routes, currentState: state }));
}
